<template>
  <div class="organization-wrapper">


    <v-card class="organization-name">
      <v-layout>
        <v-flex xs8>
          <div class="pa-2"><h2 v-if="accounts[0]">{{accounts[0].organizationName}}</h2></div>
        </v-flex>
        <v-flex xs4  class="pa-2 search" v-if="status=='SELECTED'">
          <v-text-field
            append-icon="search"
            single-line
            hide-details
            v-model="listSearch"
          ></v-text-field>
        </v-flex>
      </v-layout>
    </v-card>

    <div v-if="status=='SELECTED'">
      <v-data-table
        :headers="listHeaders"
        :items="accounts"
        :pagination.sync="pagination"
        item-key="username"
        class="elevation-1 user-list"
        :rows-per-page-items="[10]"
        :search="listSearch"
      >

      <!-- コンテンツ -->
        <template slot="items" slot-scope="props">
          <tr>
            <td>{{ props.item.username }}</td>
            <td>{{ props.item.email }}</td>
            <td>{{ props.item.roleName }}</td>
            <td>
              <div v-if="checkEditableRole(props.item.roleId,$store.getters.user.roles[0]['id'])">
                <v-menu left offset-y>
                  <v-btn icon slot="activator">
                    <v-icon class="caption">build</v-icon>
                  </v-btn>
                  <v-list>
                    <v-list-tile @click="openEditDialog(props.item)">
                      {{$t('btn.edit')}}
                    </v-list-tile>
                    <v-list-tile @click="deleteTarget=props.item;showDeleteDialog=true">
                      {{$t('btn.delete')}}
                    </v-list-tile>
                    <v-list-tile v-if="props.item.user_status===2" @click="resendMail(props.item.id)">
                      {{$t('btn.resend')}}
                    </v-list-tile>
                  </v-list>
                </v-menu>
              </div>
            </td>
          </tr>
        </template>
      </v-data-table>
    </div> <!-- status=='SELECTED' -->


    <div v-if="status=='UNSELECTED'" class="pa-3">
      <span>{{$t('user.unselected')}}</span>
    </div>

    <div v-if="status=='NODATA'" class="pa-3">
      <span>{{$t('user.nodata')}}</span>
    </div>

    <!-- 編集 ダイアログ -->
    <v-dialog v-model="showEditDialog" scrollable  max-width="450px">
      <v-card>
        <v-card-title>
          <h2>{{$t('user.edit-setting')}}</h2>
        </v-card-title>
        <v-divider></v-divider>
        <v-card-text>
          {{$t('account.can-edit-message')}}
        </v-card-text>
          <v-form ref="accountForm" class="pr-4 pl-4">
            <div class="caption pa-2 blue lighten-5">
              {{$t('user-params.username')}}:&nbsp;{{edit.username}}<br/>
              {{$t('user-params.email')}}:&nbsp;{{edit.email}}
            </div>
            <div class="mt-2 pa-2">
              <v-select
                :label="$t('account.label-role')"
                v-model="edit.roleId"
                :items="roles"
                item-text="name"
                item-value="id"
                :rules="[v => !!v || $t('account.vali-role')]"
                required
              ></v-select>
              <v-select
                :label="$t('account.label-belongto')"
                v-model="edit.organizationId"
                :items="organizations"
                item-text="name"
                item-value="organizationId"
                :rules="[v => !!v || $t('account.vali-org-select')]"
                required
                auto
              ></v-select>
              <visible-locations-set v-if="edit.roleId===8&&edit.organizationId"
                :editProp="edit" @child-action="setViewerPermission"
              />
            </div>
            <v-layout justify-center>
              <v-btn small @click.prevent="editAccount" color="primary">
                {{$t('account.edit')}}
              </v-btn>
              <v-btn flat @click.native="showEditDialog = false">
                {{$t('account.cancel')}}
              </v-btn>
            </v-layout>
          </v-form>
      </v-card>
    </v-dialog>

    <!-- 削除 ダイアログ -->
    <v-dialog v-model="showDeleteDialog" scrollable  max-width="300px">
      <v-card >
        <v-card-title>
          {{$t('account.caution-title')}}
        </v-card-title>
        <v-card-text>
          {{$t('account.caution-user-remove-text')}}<br/><br/>
          {{deleteTarget.username}}<br/>
          ({{deleteTarget.email}})<br/>
        </v-card-text>
        <v-divider></v-divider>
        <v-layout justify-center>
          <v-btn flat @click.prevent="deleteAccount" color="red">
            {{$t('account.delete')}}
          </v-btn>
          <v-btn small @click.native="showDeleteDialog = false">
            {{$t('account.cancel')}}
          </v-btn>
        </v-layout>
      </v-card>
    </v-dialog>


    <!-- メッセージ スナックバー -->
    <v-snackbar
      v-model="showSnackbar"
      absolute top right
      :color="snackbarColor"
      :timeout="snackbarTimeout"
    >
    {{snackbarMessage}}
    </v-snackbar>


  </div>
</template>

<script>
import http from '@/utils/http.js'
import RoleLabel from '@/components/RoleLabel.vue'
import VisibleLocationsSet from '@/components/AccountVisibleLocationsSetDialog.vue'
import utils from '@/utils/utils.js'

export default {
  components: {
    RoleLabel,
    VisibleLocationsSet
  },
  props: [ 'selectedOrganizationId', 'organizations', 'roles' ],
  data () {
    return {
      accounts: [],
      status: '', // 'NODATA' or 'SELECTED'
      dataTotal: null,
      listSearch: '',
      pagination: {},
      selectedAccount: [],
      listHeaders: [
        {text: this.$t('user.username'), value: 'username'},
        { text: this.$t('user.email'), value: 'email' },
        { text: this.$t('user.role'), value: 'role' },
        { text: '', sortable: false, value: '' }
      ],
      deleteTarget: [],
      showDeleteDialog: false,
      edit: [],
      showEditDialog: false,

      // snackbar
      showSnackbar: false,
      snackbarMessage: '',
      snackbarColor: '',
      snackbarTimeout: 4000
    }
  },
  computed: {
    editRoleOrganization: function () {
      return {accountId: this.edit.id, roleId: this.edit.roleId, organizationId: this.edit.organizationId}
    }
  },
  watch: {
    editRoleOrganization: {
      handler: function (val, prev) {
        if (val.accountId === prev.accountId && val.roleId !== '' && val.organizationId &&
          (val.roleId !== prev.roleId || val.organizationId !== prev.organizationId)) {
          this.edit.accountGroupResourceIds = {viewLocation: []}
        }
      },
      deep: true
    }
  },
  methods: {
    init (organizationId) {
      // 組織詳細からユーザ一覧画面に移った場合、組織一覧では押下されたままなので、反映する
      this.organizationId = organizationId
      if (this.organizationId === undefined && this.selectedOrganizationId !== null) {
        this.organizationId = this.selectedOrganizationId
      }
      if (Number.isInteger(this.organizationId)) {
        this.getAccounts(this.organizationId)
      }
    },
    checkEditableRole (targetRoleId, userRoleId) {
      return utils.checkEditableRole(targetRoleId, userRoleId)
    },
    getAccounts (organizationId) {
      http.request('get', '/service2/dashboard/api/organizations/accountList/' + organizationId)
        .then(response => {
          const data = response.data
          if (data.result !== 0) {
            // TODO エラー処理
            console.log('get account list failed. (' + data.result + ')')
            return
          }
          this.accounts = data.accounts
          this.dataTotal = data.accounts.length

          if (this.dataTotal === 0) {
            this.status = 'NODATA'
            return
          }
          this.status = 'SELECTED'
          this.accounts.forEach((account) => {
            // 一人複数のRoleを持つ設計になっているので、格納しなおす（このままだとソートできない）
            account.roleName = account.roles[0].name
            account.organizationId = organizationId
            account.roleId = Number(account.roles[0].id)
            if (account.roleId === 7) {
              account.roleName += ' (' + this.$t('viewable-locations.select-is-not-limited-viewer') + ')'
            }
            if (account.roleId === 8) {
              account.roleName = 'Viewer (' + this.$t('viewable-locations.select-is-limited-viewer') + ')'
            }
          })
        })
        .catch(error => {
          // TODO エラー処理
          console.log('error', error)
        })
    },
    openEditDialog (edit) {
      this.edit = JSON.parse(JSON.stringify(edit))
      if (this.edit.roleId === 8) {
        this.getAccountGroupResourceIds()
      }
      this.showEditDialog = true
    },
    setViewerPermission (edit) {
      this.edit = JSON.parse(JSON.stringify(edit))
    },
    editAccount () {
      if (this.edit.id === this.$store.getters.user.id) {
        // 自身のアカウントの編集はさせない（組織や権限が途中で変更された場合のバグに対応できてないため）
        this.showEditDialog = false
        this.showMessage('error', this.$t('account.cant-edit-yourself'))
        return
      }
      let roleId = this.edit.roleId
      const params = {
        accountId: this.edit.id,
        organizationId: this.edit.organizationId,
        roles: [roleId],
        accountGroupResourceIds: this.edit.accountGroupResourceIds || {viewLocation: []}
      }
      http.request('post', '/service2/dashboard/api/Accounts/updateDetail', params)
        .then(response => {
          const data = response.data
          if (data.result !== 0) {
            // TODO エラー処理
            console.log('update account data failed. (' + data.result + ')')
            this.showEditDialog = false
            this.showMessage('error', data.result)
            return
          }
          this.showEditDialog = false
          this.showMessage('success', this.$t('account.update-succeed'))
          this.getAccounts(this.organizationId)
        })
        .catch(error => {
          console.log('error', error)
          this.showEditDialog = false
          if (error.response.status === 403) {
            this.showMessage('error', this.$store.getters.message.message)
          } else {
            this.showMessage('error', error)
          }
        })
    },
    deleteAccount () {
      console.log('delete:' + this.deleteTarget.id)
      http.request('post', '/service2/dashboard/api/Accounts/deleteAccount', {accountId: this.deleteTarget.id})
        .then(response => {
          const data = response.data
          if (data.result !== 0) {
            // TODO エラー処理
            console.log('delete account failed. (' + data.result + ')')
            // this.showError(data.result)
            this.showDeleteDialog = false
            if (data.result === -32) {
              // 自身の削除
              this.showMessage('error', this.$t('account.cant-delete-yourself'))
            } else if (data.result === -31) {
              this.showMessage('error', this.$t('account.cant-delete-admin-user'))
            } else {
              this.showMessage('error', data.result)
            }
            return
          }
          // 自身の削除だった場合にログインに戻る
          if (this.$store.getters.user.id === this.deleteTarget.id) {
            this.$store.dispatch('logout') // ログアウト処理を呼び出す
            // 下記のメッセージがログイン画面に表示される
            this.$store.commit('SET_MESSAGE', {
              title: '',
              message: this.$t('account.delete-completed-myself'),
              level: 'info'
            })
            this.$router.push('/login') // ログイン画面へ
            return
          }
          this.showDeleteDialog = false
          this.showMessage('success', this.$t('account.delete-succeed'))
          this.getAccounts(this.organizationId)
        })
        .catch(error => {
          // TODO エラー処理
          console.log('error', error)
          this.showDeleteDialog = false
          this.showMessage('error', error)
        })
    },
    showMessage (result, msg) {
      switch (result) {
        case 'error':
          this.snackbarMessage = msg
          this.snackbarColor = 'red lighten-3'
          this.snackbarTimeout = 6000
          this.showSnackbar = true
          break
        case 'success':
          this.snackbarMessage = msg
          this.snackbarColor = 'teal lighten-2'
          this.snackbarTimeout = 3000
          this.showSnackbar = true
          break
        default:
          return
      }
    },
    resendMail (accountId) {
      http.request('post', '/service2/dashboard/api/accounts/inviteMail', {'accountId': accountId})
      .then(response => {
        if (response.data.result === -34) {
          this.showMessage('error', this.$t('account.already-account'))
        } else if (response.data.result === 0) {
          this.showMessage('success', this.$t('account.success-dialog'))
        } else {
          this.showMessage('error', this.$t('account.fail-dialog'))
        }
      })
      .catch(error => {
        console.log(error)
        this.showMessage('error', this.$t('account.fail-dialog'))
      })
    },
    getAccountGroupResourceIds () {
      http.request('get', '/service2/dashboard/api/accounts/accountGroupResourceList/' + this.edit.id)
        .then(response => {
          this.edit.accountGroupResourceIds = {viewLocation: response.data.viewLocation}
        })
        .catch(error => {
          // TODO エラー処理
          console.log('error', error)
        })
    }
  },
  mounted () {
    this.init()
  }
}
</script>

<style>
.user-list {
  overflow-y: scroll;
  min-height: 680px;
}


/* 検索窓のカスタマイズ */
.search .input-group {
  padding:0px;
}
.search  .input-group__input{
  padding: 2px;
  background-color: #DDD;
  border-radius:5px;
}
.search .input-group__details:before {
  background-color: rgba(0,0,0,0)!important;
}
</style>



// WEBPACK FOOTER //
// AccountOrganizationsUser.vue?272bae3c